// extracted by mini-css-extract-plugin
module.exports = {"container":"NavigationMenuContainer__container___1LKoR","fitPage":"NavigationMenuContainer__fitPage___1XuhN","enableScroll":"NavigationMenuContainer__enableScroll___1XgjJ"};